/** Append a trimmed slug if non-empty and not already present. No normalization beyond trim. */
export function addSpecialDatasetSlug(current: string[], raw: string): string[] {
  const slug = raw.trim();
  if (!slug || current.includes(slug)) return current;
  return [...current, slug];
}

/** Return `current` without `slug`. */
export function removeSpecialDatasetSlug(current: string[], slug: string): string[] {
  return current.filter((s) => s !== slug);
}
